import React from 'react';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme) => ({
	appBar: {
		backgroundColor: '#1976d2',
	},
	title: {
		flexGrow: 1,
		fontFamily: 'Montserrat, sans-serif',
		fontWeight: 900,
		marginLeft: theme.spacing(2),
	},
	accountSection: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		marginRight: theme.spacing(1),
	},
	userName: {
		fontFamily: 'Roboto, sans-serif',
		fontSize: '0.75rem',
		marginTop: theme.spacing(0.5),
	},
}));

const Header = () => {
	const classes = useStyles();

	return (
		<div className={classes.root}>
			<AppBar position="static" className={classes.appBar}>
				<Toolbar>
					<Typography variant="h6" className={classes.title}>
						Promo Viewer Application
					</Typography>
				</Toolbar>
			</AppBar>
		</div>
	);
};

export default Header;

